var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("scout-members", {
        attrs: {
          "member-objects": _vm.scoutedMemberObjects,
          "contract-id": Number(_vm.$route.params.contractId),
          "job-id": Number(_vm.$route.params.jobId),
          "display-key": "recommended",
          "data-test": "scout-members",
          count: _vm.recommendedMembers.length,
          "count-limit": _vm.recommendedMembers.length,
        },
        on: { fetch: _vm.fetchRecommendedMembers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }